import type { ClassroomModuleInfo } from "classroom/types";

export const CLASSROOM_MODULE_INFO: Record<
  "meetings" | "portfolio" | "learningGoals" | "conversations",
  ClassroomModuleInfo
> = {
  meetings: {
    flag: "meetings",
    label: "Leerlingbespreking",
    url: "https://catwise.nl/leerlingbespreking",
  },
  portfolio: {
    flag: "portfolio",
    label: "Portfolio",
    url: "https://catwise.nl/leerling-portfolio",
  },
  learningGoals: {
    flag: "learning_goals",
    label: "Leerdoelen",
    url: "https://catwise.nl/leerdoelen",
  },
  // True only when the school has the besprekingen module AND has gesprekken switched on,
  // the same pairing the conversation gates make (MEETING-CONVERSATION-MODULE-GATE-001).
  conversations: {
    flag: "conversations",
    label: "Gesprekken",
    url: "https://catwise.nl/leerlingbespreking",
  },
};
